export enum ItemBillingFlag {
	BILLED = 2,
	NOT_BILLED = 1,
	BOTH = 0,
}
